exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.compact-list--list--2cp-Bu5Z {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.compact-list--itemContentRoot--37jH5_E- {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.compact-list--subheader--28RiVokl {\n  line-height: 30px;\n  margin: 0;\n}\n\n.compact-list--itemText--drJwDh5f {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/compact-list.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,uBAAuB;EACvB,iBAAiB;CAClB;;AAED;EACE,kBAAkB;EAClB,UAAU;CACX;;AAED;EACE,wBAAwB;EACxB,iBAAiB;CAClB","file":"compact-list.css","sourcesContent":["\n.list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.itemContentRoot {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.subheader {\n  line-height: 30px;\n  margin: 0;\n}\n\n.itemText {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "compact-list--list--2cp-Bu5Z",
	"itemContentRoot": "compact-list--itemContentRoot--37jH5_E-",
	"subheader": "compact-list--subheader--28RiVokl",
	"itemText": "compact-list--itemText--drJwDh5f"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/compact-list.css
// module id = 1894
// module chunks = 4